module.exports = __webpack_public_path__ + "img/icon-distance.03ba479f.svg";